export default __webpack_public_path__ + "ad882f1740116bbf5c24cda2701bfd9a.svg";